<template>
  <div>
    <section class="section-rnc" v-if="false">
      <div class="container">
        <div class="section-space-50"></div>
        <div class="section-header-title">Refunds and Cancellation</div>
        <div class="section-space-25"></div>
        <!-- <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente
        repudiandae voluptatum ullam voluptates placeat fuga, maiores
        temporibus. Beatae consequuntur nesciunt praesentium cum harum illo quos
        iste repellat exercitationem, deserunt laudantium? Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Quas inventore deleniti dolore
        tenetur consectetur aliquam voluptatibus id laborum. Voluptas obcaecati
        magnam minus sit sunt quas a quae impedit deleniti nobis.
      </p> -->

        <div>
          <div class="font-weight-bold">Book Now, Pay Later</div>
          <ul class="p-4">
            <li>
              <p>
                Automatic Cancellation will be applicable if tickets are not
                collected 3 hours prior to the show time.
              </p>
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">COD Delivery</div>
          <ul class="p-4">
            <li>
              <p>
                Automatic Cancellation will be applicable if tickets are not
                collected 3 hours prior to the show time.
              </p>
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">Split Ticket</div>
          <ul class="p-4">
            <li>
              <p>
                Automatic Cancellation will be applicable if tickets are not
                booked 24 hours prior to the show time.
              </p>
            </li>
          </ul>
        </div>

        <!-- <div>
        <div class="font-weight-bold">1. Heading Two</div>
        <ul class="p-4">
          <li v-for="(refunds , refundsKey) in 5" :key="refundsKey">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis eum culpa deserunt, inventore quibusdam nisi distinctio quas nemo numquam tempore, rerum ab, ut beatae earum porro facilis natus repellat voluptas. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis autem obcaecati architecto cupiditate omnis dolore laborum porro. Eos, atque esse cupiditate non reiciendis explicabo amet consectetur deserunt alias quasi doloribus!</p>
          </li>
        </ul>
      </div> -->
        <div class="section-space-50"></div>
      </div>
    </section>
    <section class="section-rnc">
      <div class="container">
        <div class="section-space-50"></div>
        <div class="section-header-title">Refunds and Cancellation</div>
        <div class="section-space-25"></div>
        <div v-html="html"></div>
        <div class="section-space-50"></div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterService from "@/apiServices/MasterService";
export default {
  data() {
    return {
      html: null
    };
  },
  beforeMount() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      const { data } = await MasterService.GetPageData({
        page_code: "refunds_and_cancellations"
      });
      if (data && data.status) {
        this.html = data.data.page_data;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/refundsAndCancellation.vue